import React from 'react'
import PropTypes from 'prop-types'
import home_images from '../../assets/images/home/*.svg'

export default class TrainPositionKukoLineName extends React.Component {

  static propTypes = {
    lines: PropTypes.array.isRequired,
    trains: PropTypes.array.isRequired,
    lineName: PropTypes.string.isRequired,
    themeName: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
  }

  static contextTypes = {
    intl: PropTypes.object
  }

  render() {
    const { lineName } = this.props
    const image_url = "home_line_kuko"

    if (lineName === "koya") return null

    return (
      <div className="d-TrainPosition-lineName is_kuko is_branch_line">
        <img src={home_images[image_url]} />
      </div>
    )
  }
}
